import a from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import E from "./iconfont.es5471.js";
const i = {
  display: "block"
}, f = ({ size: e = 16, useVw: t, useRem: c, color: n, withColor: o, removeClassName: l, disableSSR: m, style: r, ...p }) => {
  const g = r ? { ...i, ...r } : i;
  return /* @__PURE__ */ a.createElement(E, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-gangganETF", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (c ? "rem" : "px"), height: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (c ? "rem" : "px"), className: l ? "" : "iconpark-icon", style: g, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: l ? "" : "32px-æ æETF"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: l ? "" : "normal",
        fill: o ? d(n, 0, "#262933") : "#262933",
        datafollowfill: o ? d(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M14.777 5.374a1.958 1.958 0 0 1 1.922-.02l2.51 1.38L25.13 10.2c.6.351.97.995.97 1.69v5.495a.9.9 0 0 0 1.8 0V11.89a3.76 3.76 0 0 0-1.861-3.244l-5.932-3.47a.926.926 0 0 0-.021-.013l-2.52-1.386a3.758 3.758 0 0 0-3.69.039L5.98 8.374A3.758 3.758 0 0 0 4.1 11.63v8.76a3.76 3.76 0 0 0 1.947 3.293l6.667 3.667a.9.9 0 0 0 .868-1.577l-6.668-3.667A1.958 1.958 0 0 1 5.9 20.389v-8.76c0-.7.373-1.346.98-1.696l7.897-4.559Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M14.768 12.232c.68-.68 1.784-.68 2.464 0l2.537 2.536c.68.68.68 1.783 0 2.464l-2.537 2.536c-.68.68-1.783.68-2.463 0l-2.537-2.536a1.742 1.742 0 0 1 0-2.464l2.537-2.536ZM13.546 16 16 13.546 18.454 16 16 18.454 13.546 16Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M27.803 21.132a.3.3 0 0 1 .244.475l-2.08 2.889 2.194 3.058a.3.3 0 0 1-.243.475h-.955a.3.3 0 0 1-.247-.13l-1.587-2.291-1.597 2.293a.3.3 0 0 1-.246.128h-.84a.3.3 0 0 1-.244-.475l2.183-3.03-2.076-2.918a.3.3 0 0 1 .245-.474h.93a.3.3 0 0 1 .246.129l1.493 2.151 1.494-2.151a.3.3 0 0 1 .246-.13h.84Zm-6.79 3.938c-.2-.282-.493-.496-.876-.64.314-.145.55-.346.707-.603a1.67 1.67 0 0 0 .245-.914c0-.377-.091-.71-.274-1a1.792 1.792 0 0 0-.772-.668 2.519 2.519 0 0 0-1.14-.245c-.56 0-1.043.141-1.451.424-.369.25-.637.6-.806 1.054a.191.191 0 0 0 .087.232l.686.392c.11.063.248.01.3-.106a1.47 1.47 0 0 1 .364-.507 1.04 1.04 0 0 1 .707-.264c.25 0 .455.072.612.217a.744.744 0 0 1 .236.574.842.842 0 0 1-.293.65c-.188.17-.461.255-.82.255h-.167a.2.2 0 0 0-.2.2v.73c0 .111.09.2.2.2h.055c.967 0 1.45.318 1.45.952 0 .29-.097.515-.291.679a1.04 1.04 0 0 1-.707.245 1.33 1.33 0 0 1-.782-.245 1.298 1.298 0 0 1-.41-.511c-.054-.116-.195-.173-.306-.11l-.724.416a.19.19 0 0 0-.085.237c.18.44.46.78.837 1.023.427.27.927.405 1.498.405a3.04 3.04 0 0 0 1.216-.235c.37-.164.662-.396.876-.698.22-.308.33-.675.33-1.102 0-.415-.1-.76-.302-1.037Z"
        }
      )
    )
  )));
}, s = f;
export {
  s as default
};
